enum FieldStatusEnum {
  PENDING = "PENDING",
  NO_TOUCH = "NO_TOUCH",
  GET_FIELDS = "GET_FIELDS",
  GET_DYNAMIC = "GET_DYNAMIC",
  SET_FILTERS = "SET_FILTERS"
}

enum UnitStatusEnum {
  PENDING = "PENDING",
  NO_TOUCH = "NO_TOUCH",
  GET_UNITS = "GET_UNITS",
  GET_DYNAMIC = "GET_DYNAMIC",
  SET_FILTERS = "SET_FILTERS"
}


enum FieldControlEnum {
  FIELDS = "FIELDS",
  TYPE = "TYPE",
  STATUS = "STATUS",
  DYNAMIC = "DYNAMIC"
}

enum UnitsControlEnum {
  UNITS = "UNITS",
  TYPE = "TYPE",
  STATUS = "STATUS",
  DYNAMIC = "DYNAMIC"
}

// type FiltersType = { [key: string]: string }
type FiltersType = string[]

type DynamicType = any[]

type OptionsType = {
  zIndex: number
}

export {FieldStatusEnum, UnitStatusEnum, FieldControlEnum, UnitsControlEnum};
export type {FiltersType, DynamicType, OptionsType};


// {
//   value: string[],
//     type: {
//   field: string[],
//     crop: string[],
//     department
// }
// }